import React from 'react';
import SystemLabel from '../../../system/SystemLabel/SystemLabel';
import { Badge } from 'reactstrap'
import TextareaAutosize from 'react-textarea-autosize'
import './BootstrapCheckbox.css'
import ContentEditable from "react-contenteditable";
import { securityHelper } from '../../../helpers/securityHelper';

String.prototype.replaceHtmlEntites = function () {
    var s = this;
    var translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    var translate = { "nbsp": " ", "amp": "&", "quot": "\"", "lt": "<", "gt": ">" };
    return (s.replace(translate_re, function (match, entity) {
        return translate[entity];
    }));
};


class JirangoCheckbox extends React.Component {
    constructor() {
        super()
        this.state = {
            disableCheckbox: false, value: '', rows: 2,
            minRows: 2,
            maxRows: 100,
        }
    };
    componentDidMount() {
        this.setState({
            value: this.props.labelName !== '' ? this.props.labelName : ''
        })
    }
    componentDidUpdate(prevProps) {
        if (this.props.labelName !== undefined && prevProps.labelName !== this.props.labelName) {
            this.setState({
                value: this.props.labelName/*  ? this.props.labelName.replaceHtmlEntites() : '' */
            })
        }
    }
    componentWillUnmount() {
        this.input = null;
    }
    disableCheckboxOnEdit = () => {
        this.setState({ disableCheckbox: true })
    }
    unDisableCheckboxOnEdit = () => {
        this.setState({ disableCheckbox: false })
    }

    onChange = (e) => {
        const { questionDto } = this.props;
        if (questionDto !== undefined) this.props.labelOnChange(e.target.value,
            questionDto.optionId,
            questionDto.langCode ? questionDto.langCode : 'swe')
        else {
            this.props.labelOnChange(e,
                this.props.path
            );
        }
        this.setState({ value: e.target.value })
    }
    render() {
        const { type, onChange, inline, labelName, value, editableLabel, labelDisabled, isEventBox, questionDto,
            labelOnChange, appendedText, checkboxIsDisabled, style, noHtmlFor, onBlur, path, editArea, boxType,
            hideCheckbox, hiddenText } = this.props;

        const boxTypeC = boxType !== undefined ? boxType : 'checkbox';
        const typeClass = type ? `${boxTypeC}-${type}` : '';
        const isInline = inline && "checkbox-inline";
        const newId = securityHelper.createGuid()/* . Math.floor(Math.random() * Math.floor(100)) */;
        const isDisabled = checkboxIsDisabled && true;
        return (
            <div className={`${hideCheckbox ? '' : boxTypeC} ${typeClass} ${isInline}`} style={{ width: '100%' }}>
                {hideCheckbox ?
                    (hiddenText ?

                        <Badge color="danger" style={{ ...style, padding: '10px', margin: '0px 5px', color: '#fff' }}>
                            {hiddenText}
                        </Badge>

                        : "")
                    :
                    <input disabled={isDisabled} onChange={(e) => onChange(e)} id={`${newId}-${labelName}`} checked={value} type={`${boxTypeC}`} />
                }

                <label htmlFor={!noHtmlFor ? `${newId}-${labelName}` : ''}>
                    {editableLabel ?
                        (
                            <React.Fragment>
                                {labelDisabled ?
                                    <p
                                        className={`option-input  `}
                                        style={{ ...style/* , maxWidth: '200px' */, cursor: 'pointer' }}>
                                        {this.state.value}
                                    </p>

                                    :
                                    <ContentEditable
                                        innerRef={this.contentEditable}
                                        className={`option-input  `}
                                        /*     onBlur={this.onBlur} */
                                        onClick={this.disableCheckboxOnEdit}
                                        onChange={(e) => this.onChange(e)}
                                        style={{ ...style/* , maxWidth: '200px' */ }}
                                        onClick={this.disableCheckboxOnEdit}
                                        html={
                                            this.state.value
                                        }
                                        disabled={labelDisabled}
                                        /*    onChange={(e) => this.onChange(e)} */
                                        tagName="p"

                                    />
                                }
                            </React.Fragment>)
                        : (<SystemLabel name={labelName} />)}
                </label>
            </div>
        )
    }

}

export default JirangoCheckbox;
